import * as React from 'react';

import { Uploader } from '.';
import { SteynCityContext } from './ContextProvider';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import styled from 'styled-components';
import { space, themeGet } from 'styled-system';
import { Box } from '../components';

type Props = StyledSystemProps & {
  src?: string;
  color?: string;
  onUploadComplete: (data: any) => void;
  onFileAdded?: (data: any) => void;
  uploadText?: string;
  acceptedFileTypes?: string[];
};

const Wrapper = styled.div<StyledSystemProps>`
  ${space};
  display: flex;
  overflow: hidden;
  flex-flow: column;
  position: relative;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid ${themeGet('colors.paleGrey', '#EEE')};
  padding-bottom: 60px;
`;

const UploaderContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;


  .uppy-Dashboard {
    height: calc(100% - 60px) !important;
  }

  .uppy-Dashboard-inner {
    width: 100% !important;
    height: 100% !important;
  }

  .uppy-Dashboard-AddFiles {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: auto;
    width: calc(100% - 40px);
    background: white;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
  }
`;

const NewFile: React.FC<Props> = (props) => {
  const context = React.useContext(SteynCityContext);
  const { onUploadComplete, onFileAdded, acceptedFileTypes } = props;

  const handleFileAdded = (file: any) => {
    // Handle the initial file selection
    if (onFileAdded) {
      onFileAdded(file);
    }
  };

  const handleUploadSuccess = (data: any) => {
    if (!data || !data[0]) {
      context.addToast('Sorry, something went wrong.', 'ERROR');
      return;
    }

    const { response } = data[0];
    console.log('Upload response:', response);

    if (response && response.body) {
      context.addToast('File added successfully.', 'SUCCESS');
      onUploadComplete(response.body);
    } else {
      context.addToast('Invalid upload response format.', 'ERROR');
    }
  };

  return (
    <Wrapper>
      <UploaderContainer>
        <Uploader
          onUpload={handleFileAdded}
          onComplete={handleUploadSuccess}
          allowedFileTypes={acceptedFileTypes || ['application/*']}
        />
      </UploaderContainer>
    </Wrapper>
  );
};

export default NewFile;



// WEBPACK FOOTER //
// ./src/components/NewFile.tsx